import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	actionButtonNonFinal: {
		id: 'periscope.suggestions.pull-request-suggestions.pull-request-comment-suggestions.action-button-non-final',
		defaultMessage: 'View',
		description:
			'This is the text on the button that will redirect the user to their pull request.',
	},
	titleNonFinal: {
		id: 'periscope.suggestions.pull-request-suggestions.pull-request-comment-suggestions.title-non-final',
		defaultMessage:
			'View {commentCount} new {commentCount, plural, one {comment} other {comments}} on your pull request',
		description: 'This is the title of the pull request comment suggestion.',
	},
	seeFullCommentNonFinal: {
		id: 'periscope.suggestions.pull-request-suggestions.pull-request-comment-suggestions.show-all-comment-non-final',
		defaultMessage: 'See full comment',
		description: 'This is the text on the button that will display full comment.',
	},
});
